import { store } from '../_helpers'
export function cancelTokenHelper() {
  return { ...store.getState().cancelToken }
}
